"use client"

import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
// import { useRouter } from "react-router-dom"
import { Search, Bell, Settings, LogOut, UserCog, Edit } from "lucide-react"

function TopNavbar() {
  const [searchQuery, setSearchQuery] = useState("")
  const [showUserMenu, setShowUserMenu] = useState(false)
  const navigate = useNavigate()
const userRole = localStorage.getItem("userRole");
const personalInfo = JSON.parse(localStorage.getItem("personalInfo"));
  const userName = personalInfo?.full_name || "User";

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const handleLogout = () => {
    localStorage.removeItem("accessToken")
    navigate("/login")
  }
    const handleEditProfile = () => {
        setShowUserMenu(false); 
    navigate("/edit-profile");
  };

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Left Side: Logo */}
          <div className="flex items-center">
            
          </div>

          {/* Right Side: Search, Actions */}
          <div className="flex items-center gap-4">
            {/* Search Bar */}
           

            {/* Action Buttons */}
            <div className="flex items-center gap-2">
              {/* Add New Product Button */}
              {userRole !== "vendor" && (
                 <>
                 <Link to="/all-order" className="hidden sm:flex items-center px-3 py-1 rounded bg-yellow-500 text-white hover:bg-yellow-600 text-sm font-medium">
              All Order</Link>
              <Link to="/add-order" className="hidden sm:flex items-center px-3 py-1 rounded bg-blue-500 text-white hover:bg-blue-600 text-sm font-medium">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
              Add Order</Link>
              <Link to="/add-product" className="hidden sm:flex items-center px-3 py-1 rounded bg-orange-500 text-white hover:bg-orange-600 text-sm font-medium">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
              Add Product</Link>
              {/* Add Purchase Button */}
              <Link
                to="/add-purchase"
                className="hidden sm:flex items-center px-3 py-1 rounded bg-green-500 text-white hover:bg-green-600 text-sm font-medium"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add Purchase
              </Link>
              </>)}
              {/* Add Sales Button */}
              {/* <Link
                to="/add-sale"
                className="hidden sm:flex items-center px-3 py-1 rounded bg-red-500 text-white hover:bg-red-600 text-sm font-medium"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add Sale
              </Link> */}
              {/* Notifications */}
             

              {/* Profile Dropdown */}
              <div className="relative">
                  
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center space-x-2 text-gray-700 hover:text-gray-900 focus:outline-none"
                >
                  {/* <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
                    <span className="text-sm font-medium text-gray-600">
                      {localStorage.getItem("userEmail")?.charAt(0).toUpperCase()}
                    </span>
                  </div> */}
                  <span className="text-sm font-medium">{localStorage.getItem("userEmail")}</span>
                  {/* <svg
                    className={`w-4 h-4 transition-transform ${showUserMenu ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg> */}
                  <UserCog  
    className="w-8 h-8 text-gray-700 hover:text-gray-900 transition"
  />
                </button>

                {/* Dropdown Menu */}
                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                   <div className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
                      <p className="font-medium">Hello {userName}</p>
                      <p className="text-gray-500">{userRole}</p>
                    </div>
                    <button
                      onClick={handleEditProfile}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                    >
                      <Edit className="w-4 h-4" />
                      Edit Profile
                    </button>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                    >
                      <LogOut className="w-4 h-4" />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopNavbar
